import { z } from 'zod';
import { createExperiment } from './createExperiment';

export const freeTierDefaultCloudProviderExperiment = createExperiment(
  'free_tier_default_cloud_provider',
  z.object({
    cloud_provider: z.enum(['', 'gcp', 'aws']),
  }),
  { cloud_provider: '' } as const,
);
